import { catchErrorsV2, turbine1dUnavailabliltyQuery } from '../ReportsAPI';
import { getSelectedItems, getTurbineIdToNameMap } from 'common/state.helper';
import { getUnavailableTurbineStatuses } from './helpers/overviewCharts.helper';

const defaultState = {
    timelineData: null,
};

export const overviewUnavailableChart = {
    name: 'overviewUnavailableChart',
    state: defaultState,

    reducers: {
        setChartData(state, { timelineData }) {
            return { ...state, timelineData };
        },
    },

    effects: (dispatch) => ({
        async loadAll() {
            catchErrorsV2(
                () => dispatch.overviewUnavailableChart.queryTimelineData(),
                () => dispatch.overviewUnavailableChart.setChartData(defaultState)
            );
        },

        async queryTimelineData(_, state) {
            const { selectedDate, selectedParkId } = getSelectedItems(state);

            const { data: turbinesUnavailableData = [] } = await turbine1dUnavailabliltyQuery(
                selectedDate,
                selectedParkId
            );

            const entityKeyToNameMap = getTurbineIdToNameMap(state);

            const timelineData = getUnavailableTurbineStatuses(
                turbinesUnavailableData,
                selectedDate,
                entityKeyToNameMap
            );

            dispatch.overviewUnavailableChart.setChartData({ timelineData });
        },
    }),
};

export default overviewUnavailableChart;
